var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Delete",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "delete-box",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("img", { attrs: { src: require("@/assets/images/logo.svg") } }),
          _c("p", [
            _vm._v(" " + _vm._s(_vm.$t("DISCIPLINE.DELETETEXT")) + " ")
          ]),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "BaseButton",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("deleteDiscpline")
                    }
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("BUTTON.YES")) + " ")]
              ),
              _c(
                "BaseButton",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("BUTTON.NO")) + " ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }